import { profile_types } from "../../../../core/components/common/variables/static_variables";
import { useRBACStore } from "../../zustand/useRBACStore";

export const getPrefixRoute = (api_endpoint) => {
    const { userType } = useRBACStore.getState();
    let prefixRoute = api_endpoint;

    let prefix = null;
    // useRBACStore.subscribe((state) => {
    //     prefix = state.apiPrefix
    //     console.log("prefixRoute bbb", prefix);
    // });

    if (!prefix) {
        // via profile type
        if (userType === profile_types.PORT_EMPLOYEE) {
            prefixRoute += '';
        }
    
        if (userType === profile_types.BUSINESS) {
            prefixRoute += '/org';
        }
    } else {
        // via manual add
        prefixRoute += prefix;
    }

    return prefixRoute;
};